import { SetLoginStateAction, UserState, UserStateParam } from 'store/redux/Authentication';
import Context from 'configuration/context';
import { authenticationServiceFactory } from 'services/authenticationService';
import { orderServiceFactory } from 'services/orderService';
import { conversationServiceFactory } from 'services/conversationService';

export const downloadAttachment = (
  id: number,
  filename: string,
  type: string,
  attachmentId: number,
  authenticationState?: UserState,
  setLoginState?: (state: UserStateParam) => SetLoginStateAction
) => {
  const file = (text: Blob) => {
    let file = new File([text], filename, {
      type: 'application/octet-stream',
    });
    let exportUrl = URL.createObjectURL(file);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = exportUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(exportUrl);
  };

  switch (type) {
    case 'order': {
      return orderServiceFactory(
        Context.APIUrl + '/v1',
        authenticationServiceFactory(Context.APIUrl, { setLoginState }, authenticationState)
      )
        .getAttachmentContent(id, attachmentId)
        .then((text: Blob) => {
          file(text);
        });
    }
    case 'conversation': {
      return conversationServiceFactory(
        Context.APIUrl + '/v1',
        authenticationServiceFactory(Context.APIUrl, { setLoginState }, authenticationState)
      )
        .getAttachmentContent(id.toString(), attachmentId.toString())
        .then((text: Blob) => {
          file(text);
        });
    }
  }
};
